const videoExtensions = [
  ".mp4",
  ".mov",
  ".avi",
  ".mkv",
  ".flv",
  ".wmv",
  ".webm",
];

const ImageSelector = ({
  label,
  name,
  value = [], // Handle multiple images as an array
  onChange,
  required = false,
  error,
  className,
  setModalOpen,
  placeholder = "Click to select an image",
  onClick,
  multiple = false,
}) => {
  // Ensure value is always an array
  const files = Array.isArray(value) ? value : [value].filter(Boolean);

  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label className="text-gray-700 mb-2 text-sm flex items-center">
          {label} {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <div
        className="relative flex flex-wrap items-center gap-2 border-2 border-dashed border-gray-300 rounded-lg p-4 bg-white hover:bg-gray-50 transition-all cursor-pointer"
        onClick={() => {
          setModalOpen(true);
          onClick();
        }}
      >
        {files.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {files.map((file, index) => (
              <div key={index} className="relative">
                {videoExtensions.some((ext) =>
                  file?.toLowerCase().endsWith(ext)
                ) ? (
                  <img
                    src="/videoThumb.jpg"
                    alt={file.originalName}
                    className="w-24 h-24 object-cover rounded-md shadow-md border border-gray-200"
                  />
                ) : file.endsWith(".pdf") ? (
                  <img
                    src="https://storage.googleapis.com/road-to-fe/uploads/1741110111744-5fb0db0b-ee21-4a9e-82f4-f09d87b3bbc6-pdfIcon.png"
                    alt="PDF"
                    className="w-24 h-24 object-cover rounded-md shadow-md border border-gray-200"
                  />
                ) : (
                  <img
                    src={file}
                    alt="Selected"
                    className="w-24 h-24 object-cover rounded-md shadow-md border border-gray-200"
                  />
                )}
                <button
                  type="button"
                  className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 text-xs shadow-md"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onChange(
                      name,
                      files.filter((_, i) => i !== index)
                    );
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-gray-500 text-sm">
            <p>{placeholder}</p>
          </div>
        )}
      </div>

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default ImageSelector;
